/**
 * CSS properties applied to elements hidden in debug mode
 * @type {string[][]}
 */
export const DEBUG_CSS_PROPERTIES = [
    ["background", "repeating-linear-gradient(to bottom, #e67370 0, #e67370 9px, white 9px, white 10px)"],
    ["outline", "solid red"]
  ];
  